export class SchemaRegistrySubject {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subject",
            "baseName": "subject",
            "type": "string",
            "format": ""
        },
        {
            "name": "latestVersion",
            "baseName": "latestVersion",
            "type": "number",
            "format": ""
        },
        {
            "name": "latestSchemaId",
            "baseName": "latestSchemaId",
            "type": "number",
            "format": ""
        },
        {
            "name": "format",
            "baseName": "format",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SchemaRegistrySubject.attributeTypeMap;
    }
    constructor() {
    }
}
